import { createAsyncThunk } from "@reduxjs/toolkit";

import { getActivities } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

const toolEventTypes = [
  "idea_added",
  "idea:created",
  "idea:destroyed",
  "idea:updated",
  "idea:reported",
  "comment:created",
  "comment:edited",
  "comment:destroyed",
  "comment:reported",
  "comment:downvoted",
  "comment:upvoted",
  "survey_response:created",
  "quick_poll_response:created",
  "quick_poll_response:updated",
  "guest_book_comment:created",
  "marker:created",
  "marker:reported",
  "marker:updated",
  "marker:deleted",
  "marker_vote:created",
  "marker_vote:deleted",
  "question:created",
  "story_telling_tool:created",
  "story_telling_tool:updated",
  "story_telling_tool:deleted",
  "forum_added",
  "forum_topic:updated",
  "forum_topic:deleted"
];

export const fetchActivities = createAsyncThunk(
  "activities/fetchActivities",
  async (params: { query?: any }, { getState, rejectWithValue }) => {
    try {
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { query } = params;
      const { token } = fetchAuthToken(getState());

      const response = await getActivities(token, baseUrl, {
        filterable: true,
        per_page: 5,
        page: 1,
        filters: {
          event_type: toolEventTypes,
          sort: { created_at: "desc" }
        },
        ...query
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
